import React from "react";

import GenericIntegrationCard from "../GenericIntegrationCard";
import { INTEGRATION_KEYS } from "../../../../integrations/IntegrationsHelper";
import steps from "../../../../integrations/onboarding/steps";
import GCalendarIcon from "../../../../common/icons/GCalendarIcon";

export default function CalendarIntegrationCard({ controller }) {
  return (
    <GenericIntegrationCard
      controller={controller}
      integrationType={INTEGRATION_KEYS.google}
      integrationStep={steps.calendar}
      IconTag={GCalendarIcon}
      title="Up to 100% automatic tracking!"
      description="Connect your Google Calendar to automatically track events."
    />
  );
}
